"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploader = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const repeat_js_1 = require("lit/directives/repeat.js");
const soojubm_png_1 = __importDefault(require("@/images/soojubm.png"));
const utils_1 = require("@/utils");
require("@/components/common/file-uploader/semantics/attachment-button");
require("@/components/common/file-uploader/semantics/attachment-item");
require("@/components/common/tag/semantics/keyword-tag-group");
require("@/components/common/text/semantics/paragraph");
async function createSampleFiles() {
    const photoBlob = await fetch(soojubm_png_1.default).then(response => response.blob());
    return [
        new File([photoBlob], 'sample-photo.png', { type: photoBlob.type }),
        new File([new Uint8Array(48000)], 'sample-document.pdf', { type: 'application/pdf' }),
        new File([new Uint8Array(1200000)], 'sample-video.mp4', { type: 'video/mp4' }),
    ];
}
let FileUploader = class FileUploader extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.label = '파일 업로드';
        this.description = '';
        this.accept = '';
        this.multiple = false;
        this.capture = false;
        this.files = [];
        this.previewUrls = new Map();
    }
    async connectedCallback() {
        super.connectedCallback();
        this.setFiles(await createSampleFiles());
    }
    render() {
        return (0, lit_1.html) `
      <mm-attachment-button
        label=${this.label}
        accept=${this.accept}
        ?multiple=${this.multiple}
        ?capture=${this.capture}
        @change=${this.handleFilesChange}
      ></mm-attachment-button>
      <mm-keyword-tag-group
        .keywords=${[this.description, this.filesStatusText].filter(Boolean)}
      ></mm-keyword-tag-group>
      <div class="attachments">
        <mm-paragraph color="light">첨부한 파일</mm-paragraph>
        ${this.renderAttachments()}
      </div>
    `;
    }
    get hasFiles() {
        return this.files.length > 0;
    }
    get filesStatusText() {
        if (!this.hasFiles)
            return 'No files currently selected for upload.';
        return `${this.files.length} file${this.files.length > 1 ? 's' : ''} selected.`;
    }
    renderAttachments() {
        if (!this.hasFiles)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <div class="attachment-list">
        ${(0, repeat_js_1.repeat)(this.files, file => file, (file, index) => (0, lit_1.html) `
            <mm-attachment-item
              file-name=${file.name}
              file-size=${this.formatFileSize(file.size)}
              preview-url=${(0, if_defined_js_1.ifDefined)(this.previewUrls.get(file))}
              type=${file.type}
              @remove=${() => this.handleRemoveClick(index)}
            ></mm-attachment-item>
          `)}
      </div>
    `;
    }
    disconnectedCallback() {
        this.revokePreviewUrls();
        super.disconnectedCallback();
    }
    handleFilesChange(event) {
        // 첨부 버튼 단위 이벤트는 여기서 끊고 uploader 단위 change로 승격한다.
        event.stopPropagation();
        this.commitFiles(event.detail.files);
    }
    handleRemoveClick(index) {
        this.commitFiles(this.files.filter((_, fileIndex) => fileIndex !== index));
    }
    commitFiles(files) {
        this.setFiles(files);
        (0, utils_1.emit)(this, 'change', { files: this.files });
    }
    setFiles(files) {
        const nextFiles = new Set(files);
        for (const [file, previewUrl] of this.previewUrls) {
            if (!nextFiles.has(file)) {
                URL.revokeObjectURL(previewUrl);
                this.previewUrls.delete(file);
            }
        }
        for (const file of files) {
            if (!file.type.startsWith('image/') || this.previewUrls.has(file))
                continue;
            this.previewUrls.set(file, URL.createObjectURL(file));
        }
        this.files = files;
    }
    revokePreviewUrls() {
        for (const previewUrl of this.previewUrls.values())
            URL.revokeObjectURL(previewUrl);
        this.previewUrls.clear();
    }
    formatFileSize(size) {
        if (size < 1024)
            return `${size} bytes`;
        if (size < 1024 * 1024)
            return `${(size / 1024).toFixed(1)} KB`;
        return `${(size / 1024 / 1024).toFixed(1)} MB`;
    }
};
FileUploader.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-2);
    }

    .attachments {
      display: flex;
      flex-direction: column;
      gap: var(--space-2);
    }

    .attachment-list {
      display: flex;
      flex-wrap: wrap;
      gap: var(--space-2);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], FileUploader.prototype, "label", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], FileUploader.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], FileUploader.prototype, "accept", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], FileUploader.prototype, "multiple", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], FileUploader.prototype, "capture", void 0);
__decorate([
    (0, decorators_js_1.state)()
], FileUploader.prototype, "files", void 0);
FileUploader = __decorate([
    (0, decorators_js_1.customElement)('mm-file-uploader')
], FileUploader);
exports.FileUploader = FileUploader;
//# sourceMappingURL=data:application/json;base64,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